/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import axios from 'axios';
import { Card, Grid, Typography, Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import signupwallpaper from '../../assets/signupwallpaper.svg';
import passwordreset from '../../assets/passwordreset.svg';
import backArrow from '../../assets/arrow-left.svg';
import {
  InputField,
  CheckBoxK,
  ButtonK,
  TestimonialCarousel,
  MainCard,
} from '@datascient/datascient-ui-library';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import { testimonials } from './Testimonials';
import CreateAccountFooter from './CreateAccountFooter';

import TermsofUseDialog from './TermsofUseDialog';

import { useNavigate } from 'react-router-dom';
import { environment } from '../../environments/environment';

const ResetPassword = () => {
  const [signupFlag, setsignupFlag] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
 
  const [termsofUse, setTermsofUse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  var navigate = useNavigate();
  // Read invite token from URL: /#/resetPassword?token=...
  const fullURL = window.location.href;
  const urlParams = new URLSearchParams(fullURL.split('?')[1]);
  const mainToken = urlParams.get('token');
  const [tokenValid, setTokenValid] = useState(true);
  const [tokenEmail, setTokenEmail] = useState('');
  const handleOpenSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };
  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarOpen(false);
  };

  // Optionally validate token to show email and handle expired/invalid
  useEffect(() => {
    const validate = async () => {
      if (!mainToken) {
        setTokenValid(false);
        handleOpenSnackbar('Missing invitation token');
        return;
      }
      try {
        const res = await axios.get(`${environment.apiUrl}/analytics/invitations/validate/${mainToken}`);
        // Backend returns email or user info
        const email = res?.data?.email || res?.data?.user?.email || '';
        setTokenEmail(email);
        setTokenValid(true);
      } catch (err) {
        setTokenValid(false);
        handleOpenSnackbar(err?.response?.data?.message || 'Invalid or expired invitation link');
      }
    };
    validate();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleLoginClick = () => {
    console.log("clicked");
    navigate("/login");
  };
  const handleChangePassword = (event) => {
    setPassword(event.target.value);
  };

  const handleChangeConfirmPassword = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
     if (!password || !confirmPassword) {
      handleOpenSnackbar('Password cannot be empty');
      return;
    } else if (password !== confirmPassword) {
      handleOpenSnackbar('Passwords do not match!');
      return;
    } else {
      getRegistration();
    }
  };

  const handleClick1 = () => {
    navigate('/login');
  };


  const handleBackClick = () => {
    
    setsignupFlag(false);
  };

  useEffect(() => {}, [signupFlag]);

  const getRegistration = async () => {
    setLoading(true);
    try {
      const payload = { token: mainToken, password };
      await axios.post(
        `${environment.apiUrl}/analytics/invitations/accept`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );
      setsignupFlag(true);
    } catch (error) {
      console.log('error', error);
      handleOpenSnackbar(error?.response?.data?.message || 'Failed to set password. Link may be invalid or expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid
      container
      style={{ margin: '0px', padding: '0px', height: '100% !important' }}
    >
      <Grid
        item
        xs={3}
        style={{
          backgroundImage: `url(${signupwallpaper})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          height: '100vh',
        }}
      >
        <Box
          style={{
            position: 'relative',
            top: '80%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            padding: '10px',
            backgroundColor: 'transparent',
          }}
        >
          <TestimonialCarousel testimonials={testimonials} />
        </Box>
      </Grid>
      <Grid
        item
        xs={9}
        style={{ backgroundColor: '#FFF', height: '100% !important' }}
      >
        {signupFlag === false && (
          <Card
            style={{
              marginLeft: '25%',
              marginRight: '25%',
              marginTop: '10%',
              borderRadius: '20px',
              boxShadow: 'none',
            }}
          >
            <Box
              style={{
                display: 'flex',
                flexDirection: 'row',
                position: 'absolute',
                top: '10px',
                right: '40px',
                margin: '10px',
              }}
            >
              <Typography
                style={{
                  color: '#131F32',
                  fontWeight: '500',
                  fontSize: '14px',
                  marginTop: '15px',
                  marginRight: '10px',
                }}
              >
                Already have an account?
              </Typography>
              <Box style={{ height: '20px', width: '45px' }}>
                <ButtonK
                  text="Login"
                  color="#159DFF"
                  backgroundColor="#FFF"
                  varient={'outlined'}
                  handleClick={handleClick1}
                />
              </Box>
            </Box>

            <Typography
              variant="h4"
              style={{
                fontSize: '32px',
                fontWeight: '600',
                textAlign: 'left',
                color: '#131F32',
                // margin: '15px',
                marginLeft: '50px',
              }}
            >
             Reset Password
            </Typography>
            <Box style={{ padding: '25px' }}>
              <InputField
                question={'Create New Password'}
                label={'Password'}
                type={'password'}
                onChange={handleChangePassword}
                required={true}
              />
              <InputField
                question={'Confirm New Password'}
                label={'Password'}
                type={'password'}
                onChange={handleChangeConfirmPassword}
                required={true}
              />
            </Box>

            <ButtonK
              text="Reset Password"
              color="#131F32"
              backgroundColor="#FFD600"
              varient="filled"
              sx={{ margin: '0 auto', display: 'block' }}
              handleClick={handleSubmit}
            />
          </Card>
        )}
        {signupFlag === true && (
          <>
            <Box
              style={{
                position: 'relative',
                left: '10px',
                width: '50px',
                marginTop: '10px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <img style={{ marginTop: '10px' }} src={backArrow} alt="." />
              <ButtonK
                text="Back"
                color="#159DFF"
                backgroundColor="#FFF"
                varient="standard"
                handleClick={handleBackClick}
              />
            </Box>

            <Box
              style={{
                width: '37%',
                textAlign: 'center',
                margin: 'auto',
                marginTop: '120px',
                // marginBottom: '190px',
              }}
            >
              <div onClick={() => {
                  // console.log("clicked");
                  navigate('/login');
                }}>
              <MainCard
                maintext="Your password has been changed"
                secondaryText="Your password has been changed. Now you can login to your account with your new password"
                logo={passwordreset}
                buttonText="Login"
                buttonColor="#131F32"
                buttonbg="#FFD600"
                buttonVarient="standard"
                handleClick={() => {
                  // console.log("clicked");
                  navigate('/login');
                }}
              />
              </div>
            </Box>
          </>
        )}

        <CreateAccountFooter />
      </Grid>
      <TermsofUseDialog
        open={termsofUse}
        handleClose={() => {
          setTermsofUse(!termsofUse);
        }}
      />
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: '9999',
          }}
        >
          <div
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
            }}
          >
            <CircularProgress
              style={{
                width: '100%',
                height: '100%',
                color:'#438BF5',
              }}
              thickness={8}
            />
          </div>
        </div>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackbar}
          severity="error"
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </Grid>
  );
};

export default ResetPassword;
